<template>
  <div class="main-content-container">
    <div class="top-content-container">
      <b-row>
        <b-col>
          <h1
            class="font-lg primary-dark font-family-medium position-relative ml-3 mt-1 mb-1"
          >
            Capacity Planning
          </h1>
          <b-dropdown-divider class="position-relative ml-3 mt-1 " />
        </b-col>
      </b-row>
    </div>
    <b-row class="ml-3 mt-3">
      <b-col class="d-flex flex-row">
        <p class="table-column-color px-2 py-1">
          Ratio of typical customer work
        </p>
        <p class="table-column-color px-2 py-1">{{ ratioOfTypicalWork }}</p>
      </b-col>
      <b-col>
        <b-button
          class="btn-danger btn-pill px-5 py-3 mt-2 mb-5 ml-4"
          @click="saveDraft"
        >
          <b-spinner
            v-if="pageLoading"
            style="width: 14px; height: 14px"
            variant="light"
            label="Spinning"
          ></b-spinner>
          {{ `${!pageLoading ? "Save Draft" : ""}` }}</b-button
        >
      </b-col>
      <b-col>
        <b-button disabled class="btn-danger btn-pill px-5 py-3 mt-2 mb-5 ml-4">
          Publish</b-button
        >
      </b-col>
    </b-row>
    <b-row class="ml-3 mt-5">
      <b-col md="2" class="d-flex p-0">
        <p></p>
      </b-col>
      <b-col md="8" class="d-flex flex-row">
        <b-col
          class="d-flex justify-content-start"
          md="1"
          v-for="month in months"
          :key="month.id"
          ><p>{{ month.value }}</p></b-col
        >
      </b-col>
    </b-row>
    <b-row class="ml-3 mt-0">
      <b-col md="2" class="d-flex p-0">
        <p>
          Total Potential Capacity
        </p>
      </b-col>
      <b-col md="8" class="d-flex justify-content-start flex-row">
        <b-col
          class="d-flex justify-content-start"
          md="1"
          v-for="capacity in totalPotentialCapacity"
          :key="capacity.monthNumber"
          ><p>{{ capacity.value.toFixed(2).toString() }}</p></b-col
        >
      </b-col>
    </b-row>
    <b-row class="ml-3 mt-0">
      <b-col md="2" class="d-flex p-0">
        <p>
          Total Assigned Capacity
        </p>
      </b-col>
      <b-col md="8" class="d-flex flex-row">
        <b-col
          class="d-flex justify-content-start"
          md="1"
          v-for="capacity in totalAssignedCapacity"
          :key="capacity.monthNumber"
          ><p>{{ capacity.value.toFixed(2).toString() }}</p></b-col
        >
      </b-col>
    </b-row>
    <b-row class="ml-3 mt-1 mb-5">
      <b-col md="2" class="d-flex p-0">
        <p>
          Total Available Capacity
        </p>
      </b-col>
      <b-col md="8" class="d-flex flex-row">
        <b-col
          class="d-flex justify-content-start"
          md="1"
          v-for="capacity in totalAvailableCapacity"
          :key="capacity.monthNumber"
          ><p>{{ capacity.value.toFixed(2).toString() }}</p></b-col
        >
      </b-col>
    </b-row>
    <b-row class="ml-3 mt-5 w-100">
      <b-col md="3" class="d-flex p-0">
        <p></p>
      </b-col>
      <b-col md="9" class="d-flex flex-row">
        <b-col
          class="d-flex justify-content-start"
          md="1"
          v-for="month in months"
          :key="month.id"
          ><p>{{ month.value }}</p></b-col
        >
      </b-col>
    </b-row>
    <div class="w-100 mb-5">
      <b-row
        class="position-relative mx-0 d-flex flex-column"
        v-for="(assistant, assistantIndex) in assistants"
        :key="assistant.assistant.id"
      >
        <div class="d-flex">
          <b-card
            style="padding-top:0;padding-bottom:0"
            class="w-100 p-0 cursor-pointer"
          >
            <b-row align-v="center">
              <b-col
                md="3"
                class="d-flex flex-row align-items-center"
                @click="assistant.isHidden = !assistant.isHidden"
              >
                <img
                  v-if="assistant.isHidden"
                  src="@/assets/icons/collapse.svg"
                  class="expand-icons mr-2"
                />
                <img
                  v-else
                  src="@/assets/icons/expand.svg"
                  class="expand-icons mr-2"
                />
                <h4 class="font-md font-family-regular mb-0">
                  {{ assistant.assistant.fullname }}
                </h4>
              </b-col>
              <b-col md="9" class="d-flex flex-row" style="height:100%">
                <b-col
                  :class="
                    parseInt(projection.value) >= 90
                      ? 'greenBackground'
                      : parseInt(projection.value) <= 90 &&
                        parseInt(projection.value) >= 65
                      ? 'redBackground'
                      : 'yellowBackground'
                  "
                  class="d-flex justify-content-center align-items-center"
                  md="1"
                  v-for="(projection, index) in assistant.totalCapacity"
                  :key="index"
                  ><p class="mb-0">{{ projection.value }}</p></b-col
                >
              </b-col>
            </b-row>
            <div v-if="!assistant.isHidden">
              <div
                @touchend="fixDragAndDropMobile"
                v-if="assistant.assignedCustomers.length > 0"
                class="mb-0"
              >
                <Container
                  @touchend="fixDragAndDropMobile"
                  :get-child-payload="getChildPayloadThree"
                  group-name="1"
                  drag-class="card-ghost"
                  drop-class="card-ghost-drop"
                  :drop-placeholder="dropPlaceholderOptions"
                >
                  <Draggable
                    v-for="(item, customerIndex) in assistant.assignedCustomers"
                    :key="item.id"
                  >
                    <CapacityCards
                      :item="item.fullname"
                      :assistantIndex="assistantIndex"
                      :customerIndex="customerIndex"
                      :projection="item.projection"
                      v-on:update="updateProjection"
                    />
                  </Draggable>
                </Container>
              </div>
              <div v-else class="d-flex justify-content-center">
                <p class="font-family-medium m-0">No Customers Assigned</p>
              </div>
              <b-row align-v="center">
                <b-col md="3" class="d-flex flex-row align-items-center">
                  <h6 class="font-sm font-family-medium ml-5 mb-0">
                    Total Assigned Hours
                  </h6>
                </b-col>
                <b-col md="9" class="d-flex flex-row" style="height:100%">
                  <b-col
                    :class="
                      parseInt(projection.value) >= 90
                        ? 'greenBackground'
                        : parseInt(projection.value) <= 90 &&
                          parseInt(projection.value) >= 65
                        ? 'redBackground'
                        : 'yellowBackground'
                    "
                    class="d-flex justify-content-center align-items-center"
                    md="1"
                    v-for="(projection, index) in assistant.totalAssignedHours"
                    :key="index"
                    ><p class="mb-0">{{ projection.value }}</p></b-col
                  >
                </b-col>
              </b-row>
              <b-row align-v="center">
                <b-col md="3" class="d-flex flex-row align-items-center">
                  <h6 class="font-sm font-family-medium mb-0 ml-5">
                    Total Available Hours
                  </h6>
                </b-col>
                <b-col md="9" class="d-flex flex-row" style="height:100%">
                  <b-col
                    :class="
                      parseInt(projection.value) >= 90
                        ? 'greenBackground'
                        : parseInt(projection.value) <= 90 &&
                          parseInt(projection.value) >= 65
                        ? 'redBackground'
                        : 'yellowBackground'
                    "
                    class="d-flex justify-content-center align-items-center"
                    md="1"
                    v-for="(projection, index) in assistant.totalAvailableHours"
                    :key="index"
                    ><p class="mb-0">{{ projection.value }}</p></b-col
                  >
                </b-col>
              </b-row>
            </div>
            <!-- <div
              v-else
              class="d-flex align-items-center justify-content-center mt-5 mb-5"
            >
              <h4>No Customers</h4>
            </div> -->
            <!-- </b-card> -->
          </b-card>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { months } from "@/utils/constants/index.js";
import { applyDrag } from "@/utils/applyDrag";
import { Container, Draggable } from "vue-smooth-dnd";
import { mapActions, mapState } from "vuex";
import { getCapacity, postDraftCapacity } from "@/apis/common";
import CapacityCards from "./CapacityCards.vue";
export default {
  name: "Capacity",
  components: {
    CapacityCards,
    Draggable,
    Container
  },
  created() {
    getCapacity().then(res => {
      let {
        yearlyProjection,
        ratioOfTypicalWork,
        assistants
      } = res.data.results;
      this.ratioOfTypicalWork = ratioOfTypicalWork;
      this.totalPotentialCapacity = [
        ...yearlyProjection.totalPotentialCapacity
      ];
      this.totalAssignedCapacity = [...yearlyProjection.totalAssignedCapacity];
      this.totalAvailableCapacity = [
        ...yearlyProjection.totalAvailableCapacity
      ];
      this.assistants = assistants.map(item => {
        item.isHidden = true;
        return item;
      });
      this.responseData = res.data;
    });
  },
  computed: {
    ...mapState("authModule", ["profileUserId"]),
    showEmptyTasksMsg() {
      console.log(this.isLoadingList);
      return (
        !this.isLoadingList &&
        this.todoTasks.length === 0 &&
        this.laterTasks.length === 0 &&
        this.inProgressTasks.length === 0 &&
        this.completedTasks.length === 0
      );
    }
  },
  data() {
    return {
      pageLoading: false,
      totalPotentialCapacity: [],
      totalAssignedCapacity: [],
      totalAvailableCapacity: [],
      profileId: "",
      role: "",
      assistants: [],
      ratioOfTypicalWork: "",
      months: months,
      showAuthError: false,
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: false
      },
      unAssignedTasks: [],
      todoTasks: [],
      laterTasks: [],
      inProgressTasks: [],
      completedTasks: [],
      shouldPatch: false,
      isLoadingList: true,
      count: null,
      responseData: {}
    };
  },

  methods: {
    ...mapActions("authModule", ["actionGetUserDetails"]),
    navigate(id) {
      this.$router.push({
        name: "AddTask",
        params: {
          statusID: id
        }
      });
    },
    updateProjection(index, assistantIndex, customerIndex) {
      for (let i = index; i < 12; i++) {
        // update customer projection
        this.assistants[assistantIndex].assignedCustomers[
          customerIndex
        ].projection[i].value = this.assistants[
          assistantIndex
        ].assignedCustomers[customerIndex].projection[index].value;

        // update total assigned hours
        let sum = 0;
        this.assistants[assistantIndex].assignedCustomers.map(item => {
          sum += parseInt(item.projection[i].value);
        });
        this.assistants[assistantIndex].totalAssignedHours[i].value = sum;
        this.assistants[assistantIndex].totalCapacity[i].value = parseInt(
          (this.assistants[assistantIndex].totalAssignedHours[i].value /
            this.assistants[assistantIndex].totalAvailableHours[i].value) *
            100
        ).toString();
        this.assistants[assistantIndex].totalCapacity[i].value += "%";

        //update total
        let capSum = 0;
        this.assistants.map(item => {
          capSum += item.totalAssignedHours[i].value;
        });
        this.totalAssignedCapacity[i].value = capSum;
        this.totalAvailableCapacity[i].value =
          this.totalPotentialCapacity[i].value - capSum;
      }
    },
    fixDragAndDropMobile() {
      // Fixes drag and drop not working in mobile
      document.body.classList.remove(
        "smooth-dnd-no-user-select",
        "smooth-dnd-disable-touch-action"
      );
      return true;
    },
    onDrop(collection, dropResult) {
      this.shouldPatch = true;
      this[collection] = applyDrag(this[collection], dropResult);
    },
    getChildPayloadThree(index) {
      return this.array[index];
    },
    saveDraft() {
      this.pageLoading = true;
      let data = { action: "draft", body: this.responseData };
      postDraftCapacity(data).then(() => {
        this.pageLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.no-assigned-msg {
  width: 95%;
  top: 75%;
}

.empty-icon-avatar {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50% !important;
  cursor: pointer;
}
.table-column-color {
  border: 1px solid #f6f9fc;
}
.smooth-dnd-container {
  background-color: #f6f9fc !important;
  border-radius: 6px;
  margin-bottom: 0rem !important;
  min-height: 0rem !important;
  // max-height: 50rem !important;
  overflow-y: auto !important;
}
.expand-icons {
  object-fit: contain;
  width: 1.5rem;
  height: 1.5rem;
}
.card-body {
  padding: 0 1.25rem;
}
.redBackground {
  background: #f4cccc;
}
.greenBackground {
  height: 100%;
  background: #b7e1cd;
}
.yellowBackground {
  background: #fff2cc;
}
</style>
